import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/navigation.css";

function Navigation() {
  return (
    <nav className="navigation">
      <NavLink to="/" className={({ isActive }) => `nav__button ${isActive ? "active" : ""}`}>
        E-commerce
      </NavLink>
      <NavLink to="/foryou" className={({ isActive }) => `nav__button ${isActive ? "active" : ""}`}>
        For You Page
      </NavLink>
      <NavLink to="/auction" className={({ isActive }) => `nav__button ${isActive ? "active" : ""}`}>
        Auction
      </NavLink>
      <NavLink to="/live" className={({ isActive }) => `nav__button ${isActive ? "active" : ""}`}>
        Live Auction
      </NavLink>

    </nav>
  );
}

export default Navigation;
